import { findWidgetDefinition } from './widgetRegistry';

/**
 * Gets the default dimensions for a widget based on its ID
 * @param widgetId - The widget identifier
 * @returns Default width and height, or default values { w: 6, h: 9 }
 */
export const getWidgetDimensions = (
  widgetId: string,
): { w: number; h: number } => {
  const definition = findWidgetDefinition(widgetId);
  return definition?.dimensions || { w: 6, h: 9 };
};
